import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-timer',
  templateUrl: './timer.component.html'
})
export class TimerComponent {}
